'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _PublicAvailabilityInfo = require('MeetingsBase/models/PublicAvailabilityInfo');

var _PublicAvailabilityInfo2 = _interopRequireDefault(_PublicAvailabilityInfo);

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _PublicAvailabilityInfo2.default();

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, (0, _fluxActions.combineActions)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED), function (state, action) {
  return action.payload.bookInfo;
}), _defineProperty(_handleActions, _ActionTypes2.default.BOOKING_TIME_CONFLICT, function (state, action) {
  return state.updateBusyTime(action.payload.userBusyTimes);
}), _defineProperty(_handleActions, _ActionTypes2.default.USER_PROFILE_FETCH_SUCCEEDED, function (state, action) {
  var calendarIntegrationChoice = action.payload.calendarIntegrationChoice;

  return state.set('integration', calendarIntegrationChoice);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/bookInfo.js
// module id = 526
// module chunks = 0